import React from "react";
import RteField from "../atom/RteField";

function CareerFormRequirement({ data = {}, onChange, errors = {} }) {
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  // Removed max-h and inner overflow so the page can scroll naturally
  return (
    <form className="grid grid-cols-1 gap-4">
      <div>
        <RteField
          label="Experience"
          value={data.experience || ""}
          onChange={(html) => handleChange("experience", html)}
          placeholder="Describe required experience"
          error={errors.experience}
        />
      </div>

      <div>
        <RteField
          label="Education Background"
          value={data.educationBackground || ""}
          onChange={(html) => handleChange("educationBackground", html)}
          placeholder="Describe education background"
          error={errors.educationBackground}
        />
      </div>
    </form>
  );
}

export default CareerFormRequirement;
